export const AFFILIATION_TYPE_LIST = ["Staff", "Student"];

export const DATE_FORMAT = "yyyy-MM-dd HH:mm:ss";

export const DATE_FORMAT_YMD_DISPLAY = "dd/MM/yyyy";
export const DATE_FORMAT_MMYYY_HHMM_DISPLAY = "dd/MM/yyyy HH:mm";

export const DATE_FORMAT_MMYYY = "MMMM yyyy";
export const DATE_FORMAT_DMM = "dd MMM";
export const DATE_FORMAT_YMD = "yyyy-MM-dd";
